import { BaseDao } from './BaseDao';
import { ApiHelper } from '../apiHelper';
import { ConstantMan } from '../constantMan';
import { Observable } from 'rxjs';
import { BuyScheduleChangeRequest, BuyScheduleChangeRequestStatus } from '../../models/buyScheduleChangeRequest';
import {HttpHeaders} from "@angular/common/http";

export class BuyScheduleChangeRequestDao extends BaseDao {
  constructor(apiHelper: ApiHelper) {
    super(ConstantMan.API.RESOURCE.BUYSCHEDULECHANGEREQUESTS, apiHelper);
  }

  findByPublicId(publicId: string, publicAuth?: boolean): Observable<any> {
    let url = this.apiHelper.getServiceName() + this.getResource() + '/public/' + publicId ;
    let headers: HttpHeaders;
    if (publicAuth) {
      headers = this.apiHelper.getChangeManagementPublicHeaders(publicId);
    } else {
      headers = this.apiHelper.getDefaultHeader();
    }
    return this.apiHelper.apiCall(
      url,
      'GET',
      null,
      null,
      headers
    );
  }

  filterRequests(reqBody: FilterChangeRequestsReqBody) {
    let url = this.apiHelper.getServiceName() + this.getResource() + '/filter-requests';
    let headers = this.apiHelper.getDefaultHeader();
    return this.apiHelper.apiCall(url, 'POST', null, reqBody, headers);
  }

  findById(id: string): Observable<any> {
    let url = this.apiHelper.getServiceName() + this.getResource() + '/' + id ;
    let headers = this.apiHelper.getDefaultHeader();
    return this.apiHelper.apiCall(
      url,
      'GET',
      null,
      null,
      headers
    );
  }

  create(buyScheduleChangeRequest: BuyScheduleChangeRequest) {
    let url = this.apiHelper.getServiceName() + this.getResource() + '/';
    let headers = this.apiHelper.getDefaultHeader();
    return this.apiHelper.apiCall(
      url,
      'POST',
      null,
      buyScheduleChangeRequest,
      headers
    );
  }

  update(data: BuyScheduleChangeRequest, publicId?: string): Observable<any> {
    let url = this.apiHelper.getServiceName() + this.getResource() + '/' + data.id;
    let headers: HttpHeaders;
    if (publicId) {
      headers = this.apiHelper.getChangeManagementPublicHeaders(publicId);
    } else {
      headers = this.apiHelper.getDefaultHeader();
    }
    delete data['$type']
    return this.apiHelper.apiCall(
      url,
      'PUT',
      null,
      data,
      headers
    );
  }
}

export interface FilterChangeRequestsReqBody {
  station?: string;
  startDate?: Date;
  endDate?: Date;
  status?: string;
  brand?: string;
}

export interface FilterChangeRequestsReqBody {
  station?: string;
  startDate?: Date;
  endDate?: Date;
  status?: string;
  brand?: string;
}
